import React, { Fragment, useMemo } from 'react'
import { Grid, MenuItem, Pagination, Select, TablePagination, Typography } from '@mui/material';
import { BtnDelete } from 'components/Button/ButtonAll';
const CustomTablePagination = (props) => {

    const { dataTable, rowsPerPage, page, setPage, setRowsPerPage, OptionRowsPerPage = [10, 25, 50, 100], colSpan, onDelete, isShowDelete } = props;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const onRowsPerPageChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Fragment>
            {
                dataTable.length > 0 ?
                    <div>

                        {
                            onDelete && isShowDelete ?
                                <BtnDelete
                                    id='btn-delete'
                                    onClick={onDelete}
                                    className='btn-delete-custom'
                                    IsCircleWithOutText
                                />
                                :
                                null
                        }
                        <TablePagination
                            rowsPerPageOptions={[]}
                            colSpan={colSpan}
                            count={dataTable.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={onRowsPerPageChange}
                            ActionsComponent={(props) => ActionsComponent(props, onRowsPerPageChange, OptionRowsPerPage)}
                            labelDisplayedRows={({ from, to, count }) => ``}
                            labelRowsPerPage={""}
                            SelectProps={{
                                hidden: true,
                                className: "none-display",
                                inputProps: {
                                    "aria-label": "page number"
                                }
                            }}
                            style={{
                                display: 'contents'
                            }}
                        />
                    </div>
                    :
                    null
            }
        </Fragment>
    )
}

export default CustomTablePagination

const ActionsComponent = (props, onRowsPerPageChange, OptionRowsPerPage) => {
    return <CustomTablePaginationActions {...props} onRowsPerPageChange={onRowsPerPageChange} OptionRowsPerPage={OptionRowsPerPage} />
};

const CustomTablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onPageChange, onRowsPerPageChange, OptionRowsPerPage } = props;
    const handleChangePage = (event, newPage: number) => {
        onPageChange(event, newPage - 1);
    };

    const lstJump = useMemo(() => {
        let nAllPage = Math.ceil(count / rowsPerPage);
        let lstPageData = [];
        for (let i = 0; i < nAllPage; i++) {
            lstPageData.push({ label: i + 1, value: i + 1 });
        }
        return lstPageData;
    }, [count, rowsPerPage])

    const TextTotal = useMemo(() => {
        let end = (page + 1) * rowsPerPage;
        let sText = `${page === 0 ? 1 : (page * rowsPerPage) + 1} - ${end > count ? count : end} of ${count}`;

        return sText;
    }, [count, page, rowsPerPage])

    return (
        <Grid container spacing={1} justifyContent={"flex-end"} alignItems={"center"}>
            <Grid item>
                หน้า
                {" "}
                <Select
                    size="small"
                    autoWidth
                    // data-testid="jump-page"
                    sx={{
                        height: 30,
                        ".MuiOutlinedInput-notchedOutline > legend": {
                            width: 0,
                        },
                    }}
                    inputProps={{ "data-testid": "jump-page" }}
                    value={page + 1}
                    onChange={(e) => {
                        handleChangePage(null, e.target.value)
                    }}
                    MenuProps={{ PaperProps: { sx: { maxHeight: 150 } } }}
                >
                    {lstJump.map((item) => {
                        let sKey = `JumpPage_${item.value}`;
                        let sLabel = item.label;
                        return (
                            <MenuItem key={sKey} value={item.value}>
                                {sLabel}
                            </MenuItem>
                        )
                    })}
                </Select>
            </Grid>
            <Grid item>
                <Typography sx={{ whiteSpace: "nowrap" }}>
                    {TextTotal}
                </Typography>
            </Grid>
            <Grid item>
                <Pagination
                    count={Math.ceil(count / rowsPerPage)}
                    variant="outlined"
                    shape="rounded"
                    size="small"
                    color="primary"
                    siblingCount={0}
                    boundaryCount={1}
                    page={page + 1}
                    showFirstButton
                    showLastButton
                    onChange={handleChangePage}
                    style={{ right: "0" }}
                />
            </Grid>
            <Grid item>
                <Select
                    labelId="select-paging-label"
                    id="select-paging"
                    // data-testid="rowperpage"
                    inputProps={{ "data-testid": "rowperpage" }}
                    value={rowsPerPage}
                    onChange={(e) => {
                        onRowsPerPageChange(e);
                    }}
                    autoWidth
                    size="small"
                    style={{ height: "31px", marginLeft: "10px" }}
                >
                    {
                        OptionRowsPerPage.map((item) => {
                            return (
                                <MenuItem value={item}>{item}</MenuItem>

                            )
                        })
                    }
                </Select>
            </Grid>
        </Grid>
    );
}

